import primary from './primary';

const secondary = (params) => primary(params);

export default secondary;
